import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleUp } from '@fortawesome/free-regular-svg-icons'
import { useScrollData } from "scroll-data-hook"

export default function GoUp() {
  const goUpHandler = () => {
    window.scrollTo(0, 0);
  }
  const { position } = useScrollData()
  return (
    <div
      className={`${position.y < 800 ? 'hidden' : ''} fixed w-[40px] h-[40px] bg-midnight z-10 flex items-center justify-center right-5 bottom-5 cursor-pointer md:right-20 md:bottom-20 rounded-full text-xl text-almost-white hover:text-white shadow-md shadow-black`}
      onClick={goUpHandler}>
      <FontAwesomeIcon icon={faArrowAltCircleUp} />
    </div>
  )
}